"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemIcone = void 0;
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importStar(require("react"));
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var menu_item_icone_styles_1 = require("./menu-item-icone.styles");
var MenuItemIcone = function (props) {
    var _a = (0, react_1.useState)(false), active = _a[0], setActive = _a[1];
    var temConteudo = props.estilo === 'dropdown';
    var onClick = temConteudo ? function () { return setActive(true); } : props.onClick;
    return (react_1.default.createElement(menu_item_icone_styles_1.ContainerStyled, { active: active, contentPosition: temConteudo ? props.posicaoConteudo : 'semConteudo', onMouseEnter: function () { return setActive(true); }, onMouseLeave: function () { return setActive(false); }, "data-testid": "container-menu-item-icone-".concat(props.label) },
        react_1.default.createElement(menu_item_icone_styles_1.BtnHeaderStyled, { "aria-label": props.ariaLabel, onClick: onClick, className: "btnMenuItemIcone", "aria-expanded": temConteudo ? active : undefined, "aria-controls": "conteudo-dropdown", "aria-haspopup": temConteudo ? 'menu' : 'false', "data-testid": "btn-menu-item-icone-".concat(props.label), "data-element": props.dataElement },
            react_1.default.createElement(menu_item_icone_styles_1.IconStyled, null, props.icone),
            active && (react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small" }, props.label))),
        temConteudo && active && (react_1.default.createElement(menu_item_icone_styles_1.ContentDropdownStyled, { id: "conteudo-dropdown", className: "content" },
            react_1.default.createElement(react_focus_lock_1.default, { autoFocus: false, returnFocus: true },
                props.conteudo,
                react_1.default.createElement("button", { className: "somenteLeitorDeTela", onClick: function () { return setActive(false); }, "data-testid": "btn-fechar-conteudo-acessibilidade" },
                    "Fechar conte\u00FAdo ",
                    props.label))))));
};
exports.MenuItemIcone = MenuItemIcone;
